
import { CertificationType } from '../certification-type.model';
import {
    CertificationTypeActions, CertificationTypeActionTypes
} from './certification-type.actions';

export interface CertificationTypeState {
  items: CertificationType[];
  loaded: boolean;
}

export const initialState: CertificationTypeState = {
  items: [],
  loaded: false,
};

export function certificationTypeReducer(state = initialState, action: CertificationTypeActions): CertificationTypeState {
  switch (action.type) {

    case CertificationTypeActionTypes.LoadCertificationTypesSuccess:
      return {
        ...state,
        items: action.payload,
        loaded: true
      };

    case CertificationTypeActionTypes.LoadCertificationTypesFail:
      return {
        ...state,
        loaded: false
      };

    default:
      return state;
  }
}
